module.exports = __webpack_public_path__ + "img/金隅嘉华大厦.a002b5b6.png";